import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { AuthenticatedLayout } from "./AuthenticatedLayout";

interface ConditionalLayoutProps {
  children: React.ReactNode;
}

export function ConditionalLayout({ children }: ConditionalLayoutProps) {
  const { user, isLoading } = useAuth();

  // Show loading while checking auth status
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // If user is authenticated, show with sidebar
  if (user) {
    return <AuthenticatedLayout>{children}</AuthenticatedLayout>;
  }

  // If not authenticated, show without sidebar
  return <div className="min-h-screen bg-background">{children}</div>;
}